import { Injectable } from "@angular/core";
import { Selector, State } from "@ngxs/store";
import { INgxsFormState } from "../../model/custom/INgxsFormState";

export class RequestDemoFormStateModel {
	public form: INgxsFormState;
}

@State<RequestDemoFormStateModel>({
	name: "requestDemoForm",
	defaults: {
		form: {
			model: null,
			dirty: false,
			status: "",
			errors: null,
		},
	},
})
@Injectable()
export class RequestDemoFormState {
	@Selector()
	static form(state: RequestDemoFormStateModel) {
		return state.form;
	}
}
